import { render, staticRenderFns } from "./approvalDialog.vue?vue&type=template&id=4aa71bfd"
import script from "./approvalDialog.vue?vue&type=script&lang=js"
export * from "./approvalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports